














































import Vue from 'vue';
import globals from '@/globals';
import Multiselect from 'vue-multiselect';
import { Component, Ref } from 'vue-property-decorator';
import { debounce } from 'lodash';
import { SEARCH } from '@/store/actions';
import { PokemonTCG } from 'pokemon-tcg-sdk-typescript';

@Component({
  components: {
    Multiselect,
  },
})
export default class SearchFilters extends Vue {
  public dispatchSearch = debounce(() => {
    this.$store.dispatch(SEARCH.REQUEST);
  }, globals.debounceInterval);

  @Ref('search-input') private readonly searchInput!: HTMLInputElement;

  get availableSets(): PokemonTCG.Set[] {
    return [{
        code: 'Standard',
        expandedLegal: true,
        logoUrl: '',
        name: 'Standard',
        ptcgoCode: '',
        releaseDate: '',
        series: '',
        standardLegal: true,
        symbolUrl: '',
        totalCards: -1,
        updatedAt: '',
        resource: () => '',
      }, {
        code: 'Expanded',
        expandedLegal: true,
        logoUrl: '',
        name: 'Expanded',
        ptcgoCode: '',
        releaseDate: '',
        series: '',
        standardLegal: true,
        symbolUrl: '',
        totalCards: -1,
        updatedAt: '',
        resource: () => '',
      }, {
        code: 'None',
        expandedLegal: true,
        logoUrl: '',
        name: 'None',
        ptcgoCode: '',
        releaseDate: '',
        series: '',
        standardLegal: true,
        symbolUrl: '',
        totalCards: -1,
        updatedAt: '',
        resource: () => '',
      },
    ].concat(this.$store.state.sets);
  }
  get placeholderSets(): string {
    // TODO: This is not how localization works
    if (!!this.filterSets && this.filterSets.length > 0) {
      if (this.filterSets.length === this.availableSets.length - 3 || this.filterSets.length === 0) {
        return 'All Sets';
      } else if (this.filterSets.length === 1) {
        return `${this.filterSets[0].name}`;
      } else {
        return `${this.filterSets.length} Sets`;
      }
    }
    return 'Sets';
  }
  get filterSets(): PokemonTCG.Set[] {
    return this.$store.state.search.sets;
  }
  set filterSets(sets: PokemonTCG.Set[]) {
    const names = sets.map((set) => set.name);
    if (names.indexOf('Post Rotation') !== -1) {
      this.$store.commit(SEARCH.SETS, this.$store.state.postRotationSets);
    } else if (names.indexOf('Standard') !== -1) {
      this.$store.commit(SEARCH.SETS, this.$store.state.standardSets);
    } else if (names.indexOf('Expanded') !== -1) {
      this.$store.commit(SEARCH.SETS, this.$store.state.expandedSets);
    } else if (names.indexOf('None') !== -1) {
      this.$store.commit(SEARCH.SETS, []);
    } else {
      this.$store.commit(SEARCH.SETS, sets);
    }
    this.dispatchSearch();
  }

  get availableSupertypes(): string[] {
    return this.$store.state.supertypes;
  }
  get filterSupertypes(): string {
    if (!!this.$store.state.search.supertypes && this.$store.state.search.supertypes.length > 0) {
      return this.$store.state.search.supertypes[0];
    }
    return '';
  }
  set filterSupertypes(supertypes: string) {
    this.$store.commit(SEARCH.SUPERTYPES, [supertypes]);
    if (this.filterSubtypes.some((subtype) => this.availableSubtypes.indexOf(subtype) === -1)) {
      this.$store.commit(SEARCH.SUBTYPES, []);
    }
    if (this.disableTypes) {
      this.$store.commit(SEARCH.TYPES, []);
    }
    this.dispatchSearch();
  }

  get availableSubtypes(): string[] {
    switch (this.filterSupertypes) {
      case 'Pokémon':
        return this.$store.state.pokemonSubtypes;
      case 'Trainer':
        return this.$store.state.trainerSubtypes;
      case 'Energy':
        return this.$store.state.energySubtypes;
      default:
        return [].concat.apply([], [
          this.$store.state.pokemonSubtypes,
          this.$store.state.trainerSubtypes,
          this.$store.state.energySubtypes,
        ]);
    }
  }
  get filterSubtypes(): string[] {
    return this.$store.state.search.subtypes;
  }
  set filterSubtypes(subtypes: string[]) {
    this.$store.commit(SEARCH.SUBTYPES, subtypes);
    this.dispatchSearch();
  }

  get availableTypes(): string[] {
    return this.$store.state.types;
  }
  get filterTypes(): string[] {
    return this.$store.state.search.types;
  }
  set filterTypes(types: string[]) {
    this.$store.commit(SEARCH.TYPES, types);
    this.dispatchSearch();
  }

  get disableTypes(): boolean {
    return this.filterSupertypes === 'Trainer' || this.filterSupertypes === 'Energy';
  }

  private filtersCollapsed = !(window.innerWidth > 550);

  public searchName(event: any) {
    this.$store.commit(SEARCH.NAME, event.target.value);
    this.dispatchSearch();
  }

  public searchText(event: any) {
    this.$store.commit(SEARCH.TEXT, event.target.value);
    this.dispatchSearch();
  }

  private mounted() {
    this.searchInput.value = this.$store.state.search.name;
  }
}
